import { render, staticRenderFns } from "./AdminAddActivityGroupModal.vue?vue&type=template&id=b9b37414&"
import script from "./AdminAddActivityGroupModal.vue?vue&type=script&lang=js&"
export * from "./AdminAddActivityGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports